import { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import logo from "../../image/alo_logo.png"
import { Alert } from "antd";
import { getCheckoutSession } from "../../services/stripeService";
import { payAnnonce } from "../../services/publicAnnonceService";

export default function PublicAnnouncementCreation() {

  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState<boolean>(true);
  const [statusMessage, setStatusMessage] = useState<string>("Vérification du paiement en cours...");
  const [annonceCreated, setAnnonceCreated] = useState<boolean>(false);
  const [paymentStatus, setPaymentStatus] = useState<string>('');
  const [ success, setSuccess ] = useState(true)

  const hasVerified = useRef(false);

  useEffect(() => {
    const paymentIntent = searchParams.get("session_id");

    const verifyPaymentAndHandleAnnonce = async (paymentIntent: string) => {
      try {
        setLoading(true);
        setStatusMessage("Vérification du paiement en cours...");

        // Vérifier le statut du paiement
        const { status, session } = await getCheckoutSession( paymentIntent );
        console.log("[DEBUG] Détail PaymentIntent :", status, session);

        setPaymentStatus(status)
        console.log("[DEBUG] Statut PaymentIntent:", status);

        if (status === "paid") {
          setStatusMessage("Création de votre annonce en cours, veuillez patienter...");

          // Ici on appelle ton backend pour créer l'annonce
          const response = await payAnnonce(paymentIntent)
          setStatusMessage("Annonce créée avec succès !");
          
          // Redirection après 2 secondes
          setTimeout(() => {
            window.location.href = "https://annonce-legale-officielle.fr/";
          }, 2000);

        } else if (status === "failed" || status === "canceled") {
          setSuccess( false )
          setStatusMessage("Échec du paiement. Votre annonce n'a pas pu être créée.");
        } else {
          setSuccess( false )
          setStatusMessage("Paiement en attente de validation. Veuillez réessayer plus tard.");
        }
      } catch (error) {
        setSuccess( false )
        console.error("[DEBUG] Erreur vérification paiement :", error);
        setStatusMessage((error as any)?.message || "Impossible de   le statut du paiement. Merci de réessayer.");
      } finally {
        setLoading(false);
      }
    };

    if (paymentIntent && !hasVerified.current) {
      verifyPaymentAndHandleAnnonce(paymentIntent);
      hasVerified.current = true;
    }
  }, [searchParams]);

  return (
    <div className="public-annonce-container">

      <div className="public-annonce-content">
      <img src = { logo } alt="" className="public-annonce-logo" />

        {
          loading
          ? <>
              { loading && <Alert message = { statusMessage } type="info" showIcon /> }
              <div className='div-public-spinner'>
                <div className="spinner-square">
                  <div className="square-1 square"></div>
                  <div className="square-2 square"></div>
                  <div className="square-3 square"></div>
                </div>
              </div>

              <br/>
            </>
          : <div className="status-message">
              <Alert message = { statusMessage } type = { success ? "success" : "error"} showIcon />
              <br/>
              { annonceCreated && <Alert message = "Votre annonce est maintenant disponible. Vous pouvez fermer cette page!" type="success" showIcon /> }
            </div>
        }
      </div>
    </div>
  );
}